import { useParams } from 'react-router-dom';
import clsx from 'clsx';
import { ReactComponent as StarlinkLogo } from 'assets/images/starlink.svg';
import { ReactComponent as StarlinkProduct } from 'assets/images/starlink_product.svg';
import { useEffect, useState } from 'react';
import CheckServiceButton from './CheckServiceButton';
import { ProductCategory } from 'screens/AccessExpressV3/accessExpress.types';

const Starlink = () => {
  const { category: routeCategory } = useParams<{
    category: ProductCategory;
  }>();
  const isAllProducts = routeCategory === 'All';

  const [shine, setShine] = useState(false);

  useEffect(() => {
    const triggerShine = () => {
      setShine(true);
      setTimeout(() => setShine(false), 5000);
    };

    triggerShine();
    const interval = setInterval(triggerShine, 15000);

    return () => clearInterval(interval);
  }, []);
  return (
    <div className="z-10 flex flex-col justify-between xl:flex-row">
      <div className="flex flex-col gap-3">
        <div className="relative flex gap-2">
          <StarlinkLogo />
        </div>
        <p className="flex flex-col justify-center font-bold">
          <span className="flex h-[38px] gap-1">
            <span className="text-[28px] text-content-base-default">
              $264.99
            </span>
            <span className="self-center text-xl text-content-base-subdued">
              /month
            </span>
          </span>
          <span className="text-xs">+$199.99 service activation fee</span>
        </p>
        <CheckServiceButton
          className="hidden max-w-[217px] xl:flex"
          variant="tertiary"
          type="Starlink"
          isAllProducts={isAllProducts}
        />
      </div>
      <div className="flex items-start justify-between gap-8 pb-3">
        <StarlinkProduct />
        <div className={clsx('p-8')}>
          <div
            className={clsx(
              'shine-effect flex flex-col items-center justify-center gap-2',
              shine && 'shine',
            )}
          >
            <div
              className={clsx(
                'flex h-6 items-center justify-center gap-1 rounded text-center text-destructive',
                'w-[94px]',
                'mb-1 bg-[#94A3B814]',
              )}
            >
              <p className="text-xs font-bold text-content-base-subdued">
                Bundles with
              </p>
            </div>
            <p className="text-base font-bold text-content-base-subdued">
              50-500G data plan
            </p>
            <p className="text-base font-bold text-content-base-subdued">
              for additional MRC.
            </p>
          </div>
        </div>
      </div>
      <CheckServiceButton
        className="mt-3 flex max-w-[217px] xl:hidden"
        variant="tertiary"
        type="Starlink"
        isAllProducts={isAllProducts}
      />
    </div>
  );
};

export default Starlink;
